export class AppError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AppError';
    // This is necessary for extending built-in classes in TypeScript
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
